import { AccordionDetails, styled } from '@mui/material';

export const Details = styled(AccordionDetails)({
  padding: 16,
  display: 'flex',
  flexDirection: 'column',
  '& > *:not(:last-child)': { marginBottom: 16 },
});
